export default __webpack_public_path__ + "static/media/gallery-image-2.4ecbe761.jpg";